import React from "react";
import { FormattedMessage } from "react-intl";
import { RoleEnum } from "../types/RoleEnum";
export var navigation = {
    aresUpdates: {
        path: "/brpublishers/ares-updates",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.ares.title" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    publisherRegistrations: {
        path: "/brpublishers/publisher-registrations",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.publisher-registrations.title" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    publisherUpdates: {
        path: "/brpublishers/publisher-updates",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.publisher-updates.title" }),
        roles: [RoleEnum.AGENCY_WORKER],
    },
    publishers: {
        path: "/brpublishers/publishers",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.publishers.title" }),
        roles: [RoleEnum.AGENCY_WORKER],
        defaultParams: { status: "ACTIVE" },
    },
    myPublisher: {
        path: "/brpublishers/my-publisher",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.my-publisher.pane.title" }),
        roles: [RoleEnum.PUBLISHER_ADMIN, RoleEnum.PUBLISHER_GUARANTOR],
        excludeSuperuser: true,
    },
    adminEnvironmentVariables: {
        path: "/brpublishers/admin/environment-variables",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.admin.title" }),
        roles: [RoleEnum.SUPERUSER],
    },
    dataImport: {
        path: "/brpublishers/data-import",
        label: React.createElement(FormattedMessage, { id: "ui-br-publishers.import.nav.title" }),
        roles: [RoleEnum.SUPERUSER],
    },
};
